import { useEffect, useState } from 'react'
import api from 'api/api'
import { isErrorResponse } from 'utils/common'
import { ApiResponse, IKycUrl } from 'typeScript/interfaces/IKyc'
import { IErrorResponse } from 'typeScript/interfaces/IErrorMessage'
import { useStore } from '@envision/ev-ui-component-library'
import { useDispatch } from 'react-redux'
import { openToast } from 'store/toast'
import { TYPE_ERROR } from 'components/Toast'
import InnerSpinner from 'components/InnerSpinner'
import { useTranslation } from 'react-i18next'

function OnboardingKYC() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [eventEmitter] = useStore.eventEmitter()
  const [kycUrl, setKycUrl] = useState<IKycUrl | IErrorResponse>({
    kyc_url: '',
  })
  const [isKYCUrlLoaded, setIsKYCUrlLoaded] = useState(false)

  const fetchKYCUrl = async () => {
    try {
      const resp = (await api.payout.getKYCUrl()) as ApiResponse<IKycUrl>
      if (resp.data) {
        setKycUrl(resp.data)
        setIsKYCUrlLoaded(true)
      }
    } catch (error) {
      setKycUrl(error as IErrorResponse)
      dispatch(openToast(TYPE_ERROR, t('toast:something_went_wrong')))
      setIsKYCUrlLoaded(true)
    }
  }

  useEffect(() => {
    const handler = (data: { state: string }) => {
      if (data.state) {
        setIsKYCUrlLoaded(false)
        fetchKYCUrl()
      }
    }

    eventEmitter.on('fetchKYCUrl', handler)
    return () => eventEmitter.off('fetchKYCUrl', handler)
  }, [])

  if (isErrorResponse(kycUrl)) {
    dispatch(openToast(TYPE_ERROR, t('toast:something_went_wrong')))
    return (
      <div className="flex justify-center items-center w-full h-[75vh] overflow-hidden mt-[2rem] rounded-[2rem]">
        <div className="relative mx-auto w-full h-full md:w-[90%] lg:w-[1024px] overflow-auto md:h-full">
          <div className="text-center text-red-600">
            {t('toast:something_went_wrong')}:<br></br>
            {kycUrl.message}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex justify-center items-center w-full h-[75vh] overflow-hidden md:mt-0 mt-[2rem] min-h-[700px] rounded-[2rem]">
      <div className="relative mx-auto w-full h-full md:w-[90%] lg:w-[1024px] overflow-auto md:h-full">
        {!isKYCUrlLoaded ? (
          <div className="flex justify-center items-center w-full h-full">
            <InnerSpinner isActive={!isKYCUrlLoaded}>
              <div>{t('payout:kyc_onboarding_loading')}</div>
            </InnerSpinner>
          </div>
        ) : (
          <iframe
            src={kycUrl.kyc_url}
            className="w-full h-full"
            title="Payaut KYC Onboarding"
          />
        )}
      </div>
    </div>
  )
}

export default OnboardingKYC
